import React, { useEffect } from 'react';
import { Dialog, DialogContent, DialogHeader, DialogTitle } from './ui/dialog';
import { X } from 'lucide-react';

const RequestAccessModal = ({ isOpen, onClose }) => {
  useEffect(() => {
    // Load the form embed script when modal opens
    if (isOpen) {
      const script = document.createElement('script');
      script.src = 'https://link.msgsndr.com/js/form_embed.js';
      script.async = true;
      document.body.appendChild(script);

      return () => {
        // Cleanup script when modal closes
        if (document.body.contains(script)) {
          document.body.removeChild(script);
        }
      };
    }
  }, [isOpen]);

  return (
    <Dialog open={isOpen} onOpenChange={onClose}>
      <DialogContent className="max-w-4xl w-[90vw] max-h-[90vh] overflow-hidden bg-[#0a2e2e] border-[#8b956d]/30 p-0">
        {/* Custom Header */}
        <div className="sticky top-0 z-10 bg-[#0a2e2e] border-b border-[#8b956d]/20 px-6 py-4 flex items-center justify-between">
          <DialogTitle className="text-2xl font-bold text-[#c5c9b8] font-['Cinzel']">
            Request Access to Excalibur CRM
          </DialogTitle>
          <button
            onClick={onClose}
            className="text-[#c5c9b8] hover:text-[#8b956d] transition-colors duration-300 flex-shrink-0"
          >
            <X className="w-6 h-6" />
          </button>
        </div>

        {/* Form Content */}
        <div className="overflow-y-auto" style={{ maxHeight: 'calc(90vh - 80px)' }}>
          <div className="p-6">
            <iframe
              src="https://api.leadconnectorhq.com/widget/form/AKla9LtsfBZOY5XMyeI4"
              style={{
                width: '100%',
                height: '100%',
                border: 'none',
                borderRadius: '3px',
              }}
              id="inline-AKla9LtsfBZOY5XMyeI4"
              data-layout="{'id':'INLINE'}"
              data-trigger-type="alwaysShow"
              data-trigger-value=""
              data-activation-type="alwaysActivated"
              data-activation-value=""
              data-deactivation-type="neverDeactivate"
              data-deactivation-value=""
              data-form-name="CRM Software Registration"
              data-height="1057"
              data-layout-iframe-id="inline-AKla9LtsfBZOY5XMyeI4"
              data-form-id="AKla9LtsfBZOY5XMyeI4"
              title="CRM Software Registration"
            />
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default RequestAccessModal;
